module.exports = __webpack_public_path__ + "static/media/Aura-big-logo.3da658b5.svg";